const MobileToggleSummary = (props) => {
  const { onToggleMobile } = props;
  const toggleMobileSummary = (e) => {
    e.preventDefault();
    onToggleMobile();
  };
  return (
    <div className="c7-checkout-template__toggle">
      <div>
        <a onClick={toggleMobileSummary}>
          <span>Show reservation summary</span>
        </a>
      </div>
    </div>
  );
};
export default MobileToggleSummary;
